<template>
  <div class="app-signup-one-time-pass-confirm-page">
    <header-pane :pageTitle="$tc('SignupPage.pageTitle')" colorType="light" />
    <div class="app-signup-one-time-pass-confirm-page__main">
      <app-signup-one-time-pass-confirm-pane @formSubmit="moveToAppConfirmationSentPage" />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from '@vue/composition-api'
import HeaderPane from '@/components/pc/common/Header/HeaderPane.vue'
import AppSignupOneTimePassConfirmPane from '@/components/AppSignupPage/AppSignupOneTimePassConfirmPane.vue'

/**
 * アプリ新規会員登録: ワンタイムパス登録確認ページ
 */
export default defineComponent({
  name: 'AppSignupOneTimePassConfirmPage',
  components: { AppSignupOneTimePassConfirmPane, HeaderPane },
  methods: {
    moveToAppConfirmationSentPage() {
      /**
       * 認証メール送信画面へ遷移
       */
      this.$router.replace({
        name: 'AppConfirmationSentPage',
        query: { appSignUpFlowType: 'one-time-pass' },
      })
    },
  },
})
</script>
